module.exports = __webpack_public_path__ + "bc91ae9887f28e0697b9eb0048ef2701.jpg";